import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";

// import event1 from "../../assets/events/event1.png";
import event2 from "../../assets/events/symposiumonSimulatorPlatform.webp";
import event3 from "../../assets/events/theAimlProgramDRDO.webp";
import event4 from "../../assets/events/exploringTheIntersectionofAI.webp";
import bioasia from "../../assets/events/BioAsia 2024.webp";
import dstTeam from "../../assets/events/dstTeamVisit.webp";
import { Link } from "react-router-dom"
import MainSubHeading from "../Sub-Heading/MainSubHeading";
import mainTips from "../../assets/events/mainTips.webp";
import callForProposal from "../../assets/events/call-for-proposals.webp";
import callForProposalDataDriven from "../../assets/events/call-for-proposals-data-driven-st.webp";
import AnavuWorkshopPDF from "../../assets/pdf/callForPurpose/AnaVu_Workshop_2025_program_list.pdf"
import AnavuWorkshopPoster from "../../assets/events/anavu-workshop.webp";
import callForPaperIntConf from "../../assets/blogs/call-for-papers-international-conference.webp";
export default function Events() {
  const subheadingData = "Events";
  const subheadingProposals = "Proposals";
  return (
    <>
      <Container>
        {/* Proposals section start */}
        <MainSubHeading subheading={subheadingProposals} />
          <Row>
            <Col xs={12} md={6} lg={4}>
            <div className="p-3">
              <div className="card-int">
                <img src={callForPaperIntConf} alt="" className="img-fluid w-100" />
                <h6>
                  Call for Papers | International Conference on Digital Demos: Data, Power and Politics in the EU and India
                </h6>
                <p>
                As data increasingly shapes governance, economies, and democratic systems, critical questions around power, 
                ownership, accountability, and regulation...
                </p>
                <div className="red-mr-btn">
                  <Button
                    className="border-0 home-btn-rd-more"
                    variant="primary" as={Link} to="/proposals/call-for-papers-international-conference-on-digital-demos"
                  >
                    Read More
                  </Button>
                </div>
              </div>
            </div>
          </Col>

            <Col xs={12} md={6} lg={4}>
              <div className="p-3">
                <div className="card-int">
                  <img src={callForProposalDataDriven} alt="" className="img-fluid w-100" />
                  <h6>
                  Data-Driven Technology research Proposals for Researchers from the Scheduled Tribe (ST) Category
                  </h6>
                    <p>
                    IHub-Data, IIIT Hyderabad invites research proposals under a special call to support researchers belonging to the Scheduled Tribe (ST) 
                    category. This initiative aims to...
                    </p>
                  <div className="red-mr-btn">
                    {/* <Link className='border-0 home-btn-rd-more' variant="primary" to="symposium-on-simulator-platform">Read More</Link> */}
                    
                  <Button className="border-0 closed-btn-rd-more " 
                    variant="secondary"
                    // href={CFPHealthcare}
                    >
                    Closed
                  </Button>
                  </div>
                </div>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4}>
              <div className="p-3">
                <div className="card-int">
                  <img src={callForProposal} alt="" className="img-fluid w-100" />
                  <h6>
                  Translational Healthcare Proposal Call
                  </h6>
                    <p>
                    IHub-Data invites proposalsfor translational research projects in the healthcare domain, with
                    a focus on Artificial Intelligence (AI), Machine Learning (ML), and Biomedical Devices. This
                    call is aimed at accelerating the development of innovative...
                    </p>
                  <div className="red-mr-btn">
                    {/* <Link className='border-0 home-btn-rd-more' variant="primary" to="symposium-on-simulator-platform">Read More</Link> */}
                    
                  <Button className="border-0 closed-btn-rd-more " 
                    variant="secondary"
                    // href={CFPHealthcare}
                    >
                    Closed
                  </Button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>


        {/* Proposals section ends */}
        <MainSubHeading subheading={subheadingData} />
        <Row>
          
          <Col xs={12} md={6} lg={4}>
              <div className="p-3">
                <div className="card-int">
                  <img src={AnavuWorkshopPoster} alt="" className="img-fluid w-100" />
                  <h6>
                  AnaVu Workshop 2025<br />IHub-Data, IIIT Hyderabad
                  </h6>
                    <p>
                    AnaVu Workshop 2025 aims to help medical faculty integrate technology into anatomy education.
                    Participants will explore innovative teaching tools and hands-on lessons....
                    </p>
                  <div className="red-mr-btn">
                    {/* <Link className='border-0 home-btn-rd-more' variant="primary" to="symposium-on-simulator-platform">Read More</Link> */}
                    
                  <Button className="border-0 home-btn-rd-more" 
                    variant="primary" 
                    href={AnavuWorkshopPDF}
                    >
                    Read More
                  </Button>
                  </div>
                </div>
              </div>
            </Col>
          
        <Col xs={12} md={6} lg={4}>
            <div className="p-3">
              <div className="card-int">
                <img src={mainTips} alt="" className="img-fluid w-100" />
                <h6>
                IHub-Data participated in TIPS 4.0 at IIT Bombay
                </h6>
                <p>
                IHub-Data participated in TIPS 4.0 (the 4th National Workshop on Technology Innovation in Cyber-Physical Systems) at IIT Bombay on May 13 and 14. 5 Tech...
                </p>
                <div className="red-mr-btn">
                  {/* <Link className='border-0 home-btn-rd-more' variant="primary" to="symposium-on-simulator-platform">Read More</Link> */}
                  
                <Button className="border-0 home-btn-rd-more" variant="primary" as={Link} to="/events/ihub-data-participated-tips-4.0">
                  Read More
                </Button>
                </div>
              </div>
            </div>
          </Col>
          
          <Col xs={12} md={6} lg={4}>
            <div className="p-3">
              <div className="card-int">
                <img src={dstTeam} alt="" className="img-fluid w-100" />
                <h6>
                DST Secretary Prof Abhay Karandikar launches IHub-Data's IDEA Lab
                </h6>
                <p>
                DST Secretary Prof Abhay Karandikar, NMICPS Member Secretary Dr Ekta Kapoor, NMICPS Member Convener Dr JBV Reddy visited IHub-Data at IIIT...
                </p>
                <div className="red-mr-btn">
                  {/* <Link className='border-0 home-btn-rd-more' variant="primary" to="symposium-on-simulator-platform">Read More</Link> */}
                  
                <Button className="border-0 home-btn-rd-more" variant="primary" as={Link} to="/events/dst-teams-visit">
                  Read More
                </Button>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4}>
            <div className="p-3">
              <div className="card-int">
                <img src={bioasia} alt="" className="img-fluid w-100" />
                <h6>
                IHub-Data team participated in BioAsia 2024
                </h6>
                <p>
                The BioAsia 2024 was hosted from February 26-28, 2024 in Hyderabad. This year the theme focused on "Data and AI: Redefining Possibilities...
                </p>
                
                <div className="red-mr-btn">
                  {/* <Link className='border-0 home-btn-rd-more' variant="primary" to="symposium-on-simulator-platform">Read More</Link> */}
                  
                <Button className="border-0 home-btn-rd-more" variant="primary" as={Link} to="/events/bio-asia-24">
                  Read More
                </Button>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4}>
            <div className="p-3">
              <div className="card-int">
                <img src={event2} alt="" className="img-fluid w-100" />
                <h6>
                Symposium on Simulator Platform for Safe Driving in Indian Road Conditions
                </h6>
                <p>
                The challenges of driving on Indian roads in unique and to improve driver safety in Indian Road Conditions, we hosted a symposium on Mobility ...
                </p>
                
                <div className="red-mr-btn">
                  {/* <Link className='border-0 home-btn-rd-more' variant="primary" to="symposium-on-simulator-platform">Read More</Link> */}
                  
                <Button className="border-0 home-btn-rd-more" variant="primary" as={Link} to="/events/symposium-on-simulator-platform">
                  Read More
                </Button>
                </div>
              </div>
            </div>
          </Col>

          <Col xs={12} md={6} lg={4}>
            <div className="p-3">
              <div className="card-int">
                <img src={event3} alt="" className="img-fluid w-100" />
                <h6>
                AI/ML Executive Training Program for DRDO scientists
                </h6>
                <p>
                  IHub-Data successfully organised a two week AI/ML executive training program for DRDO scientists. The program was held in October, 2023 at the IIIT...
                </p>
                
                <div className="red-mr-btn">
                  <Button
                    className="border-0 home-btn-rd-more"
                    variant="primary" as={Link} to="/events/the-ai-ml-program-hosted-by-ihub-Data"
                  >
                    Read More
                  </Button>
                </div>
              </div>
            </div>
          </Col>
          
          <Col xs={12} md={6} lg={4}>
            <div className="p-3">
              <div className="card-int">
                <img src={event4} alt="" className="img-fluid w-100" />
                <h6>
                Prof P Anandanspoke on AI innovation for global health
                </h6>
                <p>
                Prof P. Anandan's talk on “Translating AI Innovations into Solutions for Global Health”, in January, explored the intersection of AI and global health...
                </p>
                <div className="red-mr-btn">
                  <Button
                    className="border-0 home-btn-rd-more"
                    variant="primary" as={Link} to="/events/exploring-the-intersection-of-ai-and-global"
                  >
                    Read More
                  </Button>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}
